import React, { useState, useEffect } from 'react';
import GridLayoutSelector from '../components/GridLayoutSelector';
import PhotoCapture from '../components/PhotoCapture';
import PhotoResult from '../components/PhotoResult';
import '../styles/PhotoBooth.css';
import { useNavigate } from 'react-router-dom';

const PhotoBooth = () => {
  const [step, setStep] = useState('selection'); // selection, photo-capture, result
  const [selectedGrid, setSelectedGrid] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [photos, setPhotos] = useState([]);
  const [allPhotosHistory, setAllPhotosHistory] = useState([]);
  const [timeLeft, setTimeLeft] = useState(120); // 2 menit untuk pemilihan grid dan layout
  const [captureTimeLeft, setCaptureTimeLeft] = useState(420); // 7 menit untuk pengambilan foto
  const [indukName, setIndukName] = useState(null);
  const [recordedVideos, setRecordedVideos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    if (step === 'selection') {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            if (selectedGrid && !selectedLayout) {
              setSelectedLayout(1); // Default ke layout pertama
            }
            setStep('photo-capture');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [step, selectedGrid, selectedLayout]);

  useEffect(() => {
    let timer;
    if (step === 'photo-capture') {
      timer = setInterval(() => {
        setCaptureTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            handleComplete();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [step]);

  useEffect(() => {
    if (step === 'result') {
      try {
        // Hanya simpan data yang diperlukan untuk menghindari quota error
        const essentialData = {
          layout: selectedLayout,
          grid: selectedGrid,
          finalPhotos: photos.filter(p => p !== null).length
        };
        localStorage.setItem('sessionData', JSON.stringify(essentialData));
        
        // Hapus data lama untuk menghemat storage
        localStorage.removeItem('allPhotosHistory');
        localStorage.removeItem('photos');
        localStorage.removeItem('selectedLayout');
        localStorage.removeItem('selectedGrid');
      } catch (error) {
        console.warn('Storage quota exceeded, skipping localStorage save:', error);
      }
    }
  }, [step, allPhotosHistory, photos, selectedLayout, selectedGrid]);

  const handleSelection = ({ grid, layout }) => {
    setSelectedGrid(grid);
    setSelectedLayout(layout);
    setPhotos(Array(grid).fill(null));
    // Generate unique indukName (session name)
    const uniqueName = 'session_' + new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);
    setIndukName(uniqueName);
    setStep('photo-capture');
  };

  const handlePhotoCapture = (photo) => {
    if (Array.isArray(photo)) {
      setPhotos(photo);
      // Simpan hanya jika berbeda dari entry terakhir untuk index yang sama
      photo.forEach((p, idx) => {
        if (p && p !== photos[idx]) {
          setAllPhotosHistory(prev => {
            const lastForIndex = [...prev].reverse().find(h => h.index === idx);
            if (!lastForIndex || lastForIndex.photo !== p) {
              return [...prev, { photo: p, index: idx, timestamp: Date.now() }];
            }
            return prev;
          });
        }
      });
    } else {
      setPhotos(prev => {
        const newPhotos = [...prev];
        const emptyIndex = newPhotos.findIndex(p => p === null);
        if (emptyIndex !== -1) {
          newPhotos[emptyIndex] = photo;
          setAllPhotosHistory(prev => {
            const lastForIndex = [...prev].reverse().find(h => h.index === emptyIndex);
            if (!lastForIndex || lastForIndex.photo !== photo) {
              return [...prev, { photo, index: emptyIndex, timestamp: Date.now() }];
            }
            return prev;
          });
        }
        return newPhotos;
      });
    }
  };

  const handleVideoCapture = (videos) => {
    setRecordedVideos(videos);
  };

  const handleRetake = (index) => {
    setPhotos(prev => {
      const newPhotos = [...prev];
      newPhotos[index] = null;
      return newPhotos;
    });
  };

  const handleComplete = () => {
    setStep('result');
  };

  const handleDownload = () => {
    // Implementasi untuk mengunduh foto
    console.log('Downloading photos:', photos);
  };

  const handleShare = () => {
    // Implementasi untuk berbagi foto
    console.log('Sharing photos:', photos);
  };

  return (
    <div className="photo-booth">
      {step === 'selection' && (
        <GridLayoutSelector
          onSelect={handleSelection}
          timeLeft={timeLeft}
        />
      )}
      
      {step === 'photo-capture' && (
        <PhotoCapture
          gridCount={selectedGrid}
          layout={selectedLayout}
          photos={photos}
          onCapture={handlePhotoCapture}
          onVideoCapture={handleVideoCapture}
          onRetake={handleRetake}
          timeLeft={captureTimeLeft}
          onComplete={handleComplete}
        />
      )}

      {step === 'result' && (
        <PhotoResult
          photos={photos}
          layout={selectedLayout}
          gridCount={selectedGrid}
          allPhotosHistory={allPhotosHistory}
          onDownload={handleDownload}
          onShare={handleShare}
          indukName={indukName}
          recordedVideos={recordedVideos}
        />
      )}
      {step === 'result' && (
        <div style={{textAlign:'center',marginTop:16}}>
          <button onClick={() => navigate(`/gallery/${indukName || ''}`)} style={{padding:'8px 20px',fontSize:16}}>Lihat Semua Hasil & Video</button>
        </div>
      )}
    </div>
  );
};

export default PhotoBooth; 